module.exports = __webpack_public_path__ + "img/Flag-map_of_Kuwait.4382d41e.svg";